/* pageAbout.js */
import { modalManager } from '../UI/modalManager.js';
import { langManager } from '../lang/langManager.js';
import { log } from '../utils/logging.js';

/*********************************************
 * Page Configuration
 *********************************************/
const scenePageMap = {
  home: '/',
  market: '/market',
  catering: '/catering',
  about: '/about',
  games: '/games',
  boutique: '/boutique'
};

const pageConfig = {
  initialScene: 'about',
  navigationMode: 'spa',
  history: true,
  scenePageMap,
  prefetchScenes: ['home', 'market', 'catering', 'games', 'boutique']
};

if (!window.__BUBAR_PAGE__) {
  window.__BUBAR_PAGE__ = pageConfig;
}

import('../core/page.js').catch(err => console.error('Failed to load page runtime', err));

/********************************
 * About Modal Registration
 ********************************/

// Register the about modal
modalManager.registerModal('about', 'about-modal', {
  initialize: modalElement => {
    langManager.updatePageText();

    const handler = () => langManager.updatePageText();
    window.addEventListener('languageChanged', handler);

    return () => window.removeEventListener('languageChanged', handler);
  },

  updateContent: () => langManager.updatePageText()
});

// Export function for external use
export function openAboutModal() {
  return modalManager.openModal('about', 'about-modal');
}
